import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Article } from 'pages/topics/[slug]';

import ArticleCard from 'components/article-card';
import Divider from 'components/divider';
import { Link } from 'components/router';
import { Heading, Text } from 'components/typography';

type TopicArticlesProps = {
  name: string;
  articles: Article[];
  moreLink?: string;
};

function TopicArticles({
  name,
  articles,
  moreLink
}: TopicArticlesProps): React.ReactNode {
  return (
    <section id="articles" tabIndex={-1}>
      <Heading size="l" className="mb-8">
        <FormattedMessage
          defaultMessage="Exclusive articles about {topicName}"
          values={{ topicName: name }}
        />
      </Heading>
      {articles.map((article, index) => {
        return (
          <React.Fragment key={article.link}>
            {index > 0 && <Divider className="my-8" />}
            <ArticleCard
              datePosted={article.datePosted}
              description={article.description}
              image={article.thumbnail}
              link={article.link}
              title={article.title}
            />
          </React.Fragment>
        );
      })}

      {moreLink && (
        <Link href={moreLink} className="mt-8 inline-block">
          <Text
            size="m"
            tagName="span"
            className="font-bold underline transition-colors hover:text-gray-700"
          >
            <FormattedMessage
              defaultMessage="See all articles on {topicName}"
              values={{ topicName: name }}
            />
          </Text>
        </Link>
      )}
    </section>
  );
}

export default TopicArticles;
